import { Component, OnInit } from '@angular/core';
import { AgentService } from '@core/services/agent.service';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { LoadingService } from '@core/services/loading.service';
import { LocaleService } from '@core/services/locale.service';
import { PolicyService } from '@core/services/policy.service';
import { HomeComponent } from '../home.component';
import { Router } from '@angular/router';
import { Policy } from '@shared/models/policy';
import { B2bService } from '@core/services/b2b.service';


@Component({
  selector: 'app-home-b2b-lease',
  templateUrl: './home-b2b-lease.component.html',
  styleUrls: ['./home-b2b-lease.component.scss'],
  standalone: false
})
export class HomeB2BLeaseComponent extends HomeComponent implements OnInit {

  constructor(
    public commonService: CommonService,
    public b2b: B2bService,
    protected dataService: DataService,
    protected router: Router,
    protected localeService: LocaleService,
    protected agentService: AgentService,
    private policyService: PolicyService,
    protected loadingService: LoadingService
  ) {
    super(commonService, dataService, router, localeService, agentService, loadingService);
  }

  ngOnInit(): void {
    this.policyService.getActivePolicies().subscribe(policies => {
      this.groupPolicies(policies);
    });
  }
}
